import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

type Args = {
    customerId: string | null;
    email: string | null;
    token: string | null;
};

export default function getExportPriceList({ customerId, email, token }: Args) {
    if (!customerId || !email) {
        return Promise.reject(new Error(shopErrors.exportPriceList.message));
    }
    return shop
        .post(getUrl(`/customers/${customerId}/export-price-list?email=${email}`), {
            json: {
                customerId,
                email,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .json<ShopTypes.ProblemDetails>();
}
